import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { NavigationExtras } from '@angular/router';
import { IconPrefix, IconProp } from '@fortawesome/fontawesome-svg-core';
import { HubInstance } from '@meplis/common';
import { Observable } from 'rxjs';

export abstract class Common {
  public abstract isMobile: boolean;
  public abstract nextRoute: string;

  public abstract getIcon(
    value: string,
    iconPrefixValue?: IconPrefix
  ): IconProp;

  public abstract init(): Promise<void>;

  public abstract get isPlatformBrowser(): boolean;

  public abstract get isPlatformServer(): boolean;

  public abstract navigate(
    pathArray: string[],
    extras?: NavigationExtras,
    openNewTab?: boolean
  ): void;

  public abstract navigateByUrl(
    path: string,
    extras?: NavigationExtras,
    openNewTab?: boolean
  ): void;

  public abstract getBasePath(region?: string, language?: string): string;

  public abstract setNextRoute(nextRoute: string): void;

  public abstract goToNextRoute(): Promise<void>;

  public abstract redirectDefaultRoute(): Promise<void>;

  public abstract handleBaseUrl(
    hub: string,
    region?: string,
    language?: string
  ): Promise<void>;

  public abstract verifyIfIsMobile(): void;

  public abstract isMobileChangeObservable(): Observable<void>;

  public abstract setSEOConfiguration(hubInstance: HubInstance): void;

  public abstract setTheme(): Promise<void>;

  public abstract downloadFileFromUrl(
    url: string,
    fileName: string
  ): Promise<void>;

  public abstract windowOpen(
    url?: string | URL,
    target?: string,
    features?: string
  ): void;
}
